export const DATE_FORMAT = "MM/DD/YYYY" as const;
